import { render } from "./NdsDlg.vue?vue&type=template&id=5c0a1801&scoped=true"
import script from "./NdsDlg.vue?vue&type=script&lang=js"
export * from "./NdsDlg.vue?vue&type=script&lang=js"

import "./NdsDlg.vue?vue&type=style&index=0&id=5c0a1801&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0a1801"]])

export default __exports__